import { Grid } from "@mui/material";
import React from "react";
import DashboardAccess from "./DashboardAccess";
import PosAccess from "./PosAccess";
import InputAccessLayout from "./InputAccessLayout";
import SalesHistoryAccess from "./SalesHistoryAccess";
import CashMgmtAccess from "./CashMgmtAccess";
import CatalogAccess from "./CatalogAccess";
import CategoryAccess from "./CategoryAccess";
import BrandAccess from "./BrandAccess";
import TagAccess from "./TagAccess";
import ProductAttributeAccess from "./ProductAttributeAccess";
import SupplierAccess from "./SupplierAccess";
import StockAccess from "./StockAccess";
import StockReturnAccess from "./StockReturnAccess";
import InqueryAccess from "./InqueryAccess";
import CustomerAccess from "./CustomerAccess";
import CustomerGroupAccess from "./CustomerGroupAccess";
import FollowUpTypeAccess from "./FollowUpTypeAccess";
import InquerySourceAccess from "./InquerySourceAccess";
import ReportAccess from "./ReportAccess";
import OutletAccess from "./OutletAccess";
import PaymentTypeAccess from "./PaymentTypeAccess";
import TaxRateAccess from "./TaxRateAccess";
import UserAccess from "./UserAccess";
import CurrencyAccess from "./CurrencyAccess";

const FeaturePermissionForm = ({ values, setValues }) => {
  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    name && setValues((j) => ({ ...j, [name]: checked }));
  };

  return values ? (
    <div className="mt-[10px]" style={{ maxHeight: "70vh", overflowY: "auto" }}>
      <Grid container spacing={2.5} className="p-[10px]">
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Settings > General Access",
              name: "generalAccess",
              values,
              className: "font-normal",
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Settings > Status",
              name: "status",
              values,
              className: "font-normal",
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Settings > User Role Access",
              name: "userRoleAccess",
              values,
              className: "font-normal",
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Print Label Access",
              name: "printLabelAccess",
              values,
              className: "font-normal",
            }}
          />
        </Grid>

        {/* ===== Dashboard Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Dashboard Access",
              name: "dashboardAccess",
              values,
              AccessComponet: <DashboardAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== POS Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "POS Access",
              name: "posAccess",
              values,
              AccessComponet: <PosAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Sales Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Sales History Access",
              name: "salesHistoryAccess",
              values,
              AccessComponet: <SalesHistoryAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Category Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Category Access",
              name: "categoryAccess",
              values,
              AccessComponet: <CategoryAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Stock Return Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Stock Return Access",
              name: "stockReturnAccess",
              values,
              AccessComponet: <StockReturnAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Cash Management Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Cash Management Access",
              name: "cashMgmtAccess",
              values,
              AccessComponet: <CashMgmtAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Catalog Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Catalog Access",
              name: "catalogAccess",
              values,
              AccessComponet: <CatalogAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Inquery Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Inquery Access",
              name: "inqueryAccess",
              values,
              AccessComponet: <InqueryAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Brand Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Brand Access",
              name: "brandAccess",
              values,
              AccessComponet: <BrandAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Tag Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Tag Access",
              name: "tagAccess",
              values,
              AccessComponet: <TagAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Product Attributes Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Product Attribute Access",
              name: "productAttributeAccess",
              values,
              AccessComponet: (
                <ProductAttributeAccess {...{ values, setValues }} />
              ),
            }}
          />
        </Grid>

        {/* ===== Customer Group Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Customer Group Access",
              name: "customerGroupAccess",
              values,
              AccessComponet: (
                <CustomerGroupAccess {...{ values, setValues }} />
              ),
            }}
          />
        </Grid>

        {/* ===== Customer Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Customer Access",
              name: "customerAccess",
              values,
              AccessComponet: <CustomerAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>
        {/* ===== Supplier Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Supplier Access",
              name: "supplierAccess",
              values,
              AccessComponet: <SupplierAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Stock Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Stock Access",
              name: "stockAccess",
              values,
              AccessComponet: <StockAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Outlet Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Outlet Access",
              name: "outletAccess",
              values,
              AccessComponet: <OutletAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Follow Up Type Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Follow Up Type Access",
              name: "followUpTypeAccess",
              values,
              AccessComponet: <FollowUpTypeAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Inquery Source Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Inquery Source Access",
              name: "inquerySourceAccess",
              values,
              AccessComponet: (
                <InquerySourceAccess {...{ values, setValues }} />
              ),
            }}
          />
        </Grid>

        {/* ===== Report Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Report Access",
              name: "reportAccess",
              values,
              AccessComponet: <ReportAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Payment Type Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Payment Type Access",
              name: "paymentTypeAccess",
              values,
              AccessComponet: <PaymentTypeAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Payment Type Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Currency Access",
              name: "currencyAccess",
              values,
              AccessComponet: <CurrencyAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== Tax Rate Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "Tax Rate Access",
              name: "taxRateAccess",
              values,
              AccessComponet: <TaxRateAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>

        {/* ===== User Access ===== */}
        <Grid item xs={12} md={6}>
          <InputAccessLayout
            {...{
              handleInpChg,
              title: "User Access",
              name: "userAccess",
              values,
              AccessComponet: <UserAccess {...{ values, setValues }} />,
            }}
          />
        </Grid>
      </Grid>
    </div>
  ) : (
    <span className="p-[20px] text-[18px] font-medium text-gray-500">
      Loading...
    </span>
  );
};

export default FeaturePermissionForm;
